<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Consulta de Liquidaciones de Venta</h3>
            </div>
            <div class="layout__controls">
                <div class="form-inline">
                    <button @click="imprimir" class="btn-danger btn--bigger">
                        <i class="fa fa-file-pdf-o"></i><span>Exportar</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Información de la consulta</h5>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select2">
                            <div class="select2-field">
                                <v-select
                                placeholder="Seleccione..."
                                id="vendedor_id"
                                v-model="selectedVendedores"
                                :options="vendedores"
                                @input="inputVendedores"
                                @search="searchVendedores"
                                label="descripcion"
                                multiple
                                ></v-select>
                                <label for="vendedor_id">Vendedor</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select">
                            <div class="select-field">
                                <select name="tipo_fecha" id="tipo_fecha" v-model="form.tipo_fecha">
                                    <option value="H">Hoy</option>
                                    <option value="A">Ayer</option>
                                    <option value="P">Personalizada</option>
                                </select>
                                <label for="fecha">Fecha</label>
                            </div>
                        </div>
                    </div>
                    <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="datepicker-field">
                                <VueCtkDateTimePicker
                                id="desde"
                                v-model="form.desde"
                                locale="es"
                                only-date
                                no-label
                                button-now-translation="Ahora"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                label="Seleccione fecha..."
                                />
                                <label>Desde</label>
                            </div>
                        </div>
                    </div>
                    <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="datepicker-field">
                                <VueCtkDateTimePicker
                                id="hasta"
                                v-model="form.hasta"
                                locale="es"
                                only-date
                                no-label
                                button-now-translation="Ahora"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                label="Seleccione fecha..."
                                />
                                <label>Hasta</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            buttons: [],
            form: {
                tipo_fecha: 'H',
                desde: moment(new Date()).format('YYYY-MM-DD'),
                hasta: moment(new Date()).format('YYYY-MM-DD'),
                vendedores_id:  [],
                tipo_consulta: 'P'
            },
            selectedVendedores: [],
            path: url + '/consulta-liquidaciones-venta',
            vendedores: []
        };
    },
    methods: {
        serialize: function (obj) {
            return (
                "?" +
                Object.keys(obj)
                .reduce(function (a, k) {
                    let val = obj[k];
                    let esArray = false;
                    if (val instanceof Date) {
                    val = val.toLocaleDateString("en");
                    } else if (val instanceof Array) {
                    esArray = true;
                    let acumulador = "";
                    for (let i = 0; i < val.length; i++) {
                        acumulador += k + "%5B%5D=" + val[i];
                        if (i != val.length - 1) {
                        acumulador += "&";
                        }
                    }
                    val = acumulador;
                    a.push(val);
                    }
                    if (!esArray) a.push(k + "=" + encodeURIComponent(val));
                    return a;
                }, [])
                .join("&")
            );
        },
        imprimir: function () {
            window.open(url + '/historial-ventas-vendedor' + this.serialize(this.form), '_blank');
        },
        searchVendedores: function (search, loading) {
            loading(true);
            let that = this;
            let xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function () {
                if (
                (this.readyState == 4 && this.status == 200) ||
                this.status == 201
                ) {
                let json = JSON.parse(this.responseText);
                that.vendedores = json;
                loading(false);
                } else loading(false);
            };
            xmlhttp.open("GET", url + "/search/vendedores?search=" + search, true);
            xmlhttp.send();
        },
        inputVendedores: function () {
            this.form.vendedores_id.splice(0, this.form.vendedores_id.length);
            for (let i = 0; i < this.selectedVendedores.length; i++) {
                this.form.vendedores_id.push(this.selectedVendedores[i].id);
            }
        }
    },
    props: {
        tipo_fecha: {
            type: String,
            required: false,
            default: ''
        },
        desde: {
            type: String,
            required: false,
            default: ''
        },
        hasta: {
            type: String,
            required: false,
            default: ''
        },
        vendedor: {
            type: Object,
            required: false,
            default: function () {
                return null;
            }
        }
    },
    mounted: function () {
        if (this.vendedor != null) {
            this.selectedVendedores.push(this.vendedor);
            this.inputVendedores();
            this.form.desde = this.desde;
            this.form.hasta = this.hasta;
            this.form.tipo_fecha = this.tipo_fecha;
            this.imprimir();
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/nomina/HistorialVentasVendedor.vue